import { ChangeDetectionStrategy, Component } from '@angular/core'
import { JobBrowserComponent } from '../job-browser/job-browser.component'
import { Job, JobKind } from '../job'
import { Router } from '@angular/router'

@Component({
  selector: 'app-jobs-overview',
  imports: [JobBrowserComponent],
  templateUrl: './jobs-overview.component.html',
  styleUrl: './jobs-overview.component.scss',
})
export class JobsOverviewComponent {
  protected JobKind = JobKind

  constructor(private router: Router) {}

  public openSideDetail(job: Job): void {
    this.router.navigate([{ outlets: { side: ['jobs', job.id] } }])
  }
}
